export interface CATEdiciones {
    numeroEdicion:number;
    id:number;
    codigoCuenta:string;
    fechaDeInicioInscripcion: any
    fechaDeFinalizacionInscripcion: any
    fechaDeInicioDuracion: any
    fechaDeFinalizacionDuracion: any
    fechaInicioEntrevista: any
    fechaFinalEntrevista: any
    fechaInicioPropedeutico: any
    fechaFinalPropedeutico: any
    limiteCupo: number
    cupoActual: number
    edicionEspecial: boolean
    preInscripcion: boolean
    aprobadoPor: string
    catCursosId: string
    year: any
    is_active: boolean
    catedratico: string
    nivel: string
    certificacion: string

    fechasMaestria: CATFechaMaestriProceso[]
}

export interface CATFechaMaestriProceso {
    id: number;
    fechaInicio: Date;
    fechaFinal: Date;
    tipo: string
}

export class CATFechaProceso implements CATFechaProceso{
    constructor (init:CATEdicionesFormValues){
        Object.assign(this,init);
    }
}

export class CATEdiciones implements CATEdiciones{
    constructor (init:CATEdicionesFormValues){
        Object.assign(this,init);
    }
}

export class CATEdicionesFormValues{
    numeroEdicion:number=0;
    id:number=0;
    codigoCuenta:string="";
    fechaDeInicioInscripcion: Date | null = null
    fechaDeFinalizacionInscripcion: Date | null = null
    fechaDeInicioDuracion: Date | null = null
    fechaDeFinalizacionDuracion: Date | null = null
    fechaInicioEntrevista: Date | null = null
    fechaFinalEntrevista: Date | null = null
    fechaInicioPropedeutico: Date | null = null
    fechaFinalPropedeutico: Date | null = null
    limiteCupo: number = 0
    cupoActual: number = 0
    edicionEspecial: boolean = false
    preInscripcion: boolean = false
    aprobadoPor: string = ""
    catCursosId: string = ""
    year: number = 0
    is_active: boolean = false
    catedratico: string = ""
    fechasMaestria: any
    nivel: string = ""
    certificacion: string = "1"

    constructor(CATEdiciones?:CATEdicionesFormValues){
        if(CATEdiciones){
            this.numeroEdicion = CATEdiciones.numeroEdicion;
            this.id = CATEdiciones.id;
            this.codigoCuenta = CATEdiciones.codigoCuenta;
            this.fechaDeInicioInscripcion = CATEdiciones.fechaDeInicioInscripcion
            this.fechaDeFinalizacionInscripcion = CATEdiciones.fechaDeFinalizacionInscripcion
            this.fechaDeInicioDuracion = CATEdiciones.fechaDeInicioDuracion
            this.fechaDeFinalizacionDuracion = CATEdiciones.fechaDeFinalizacionDuracion
            this.fechaInicioEntrevista = CATEdiciones.fechaInicioEntrevista
            this.fechaFinalEntrevista = CATEdiciones.fechaFinalEntrevista
            this.fechaInicioPropedeutico = CATEdiciones.fechaInicioPropedeutico
            this.fechaFinalPropedeutico = CATEdiciones.fechaFinalPropedeutico
            this.limiteCupo = CATEdiciones.limiteCupo
            this.cupoActual = CATEdiciones.cupoActual
            this.edicionEspecial = CATEdiciones.edicionEspecial
            this.preInscripcion = CATEdiciones.preInscripcion
            this.aprobadoPor = CATEdiciones.aprobadoPor
            this.catCursosId = CATEdiciones.catCursosId
            this.year = CATEdiciones.year
            this.is_active = CATEdiciones.is_active
            this.catedratico = CATEdiciones.catedratico
            this.certificacion = CATEdiciones.certificacion
            this.nivel = CATEdiciones.nivel
        }
    }
}

export interface CATEdicionesL {
    id:number;
    codigo:number;
    fechas:string;
}

export class CATEdicionesL implements CATEdicionesL{
    constructor (init:CATEdicionesFormValues){
        Object.assign(this,init);
    }
}

export class CATEdicionesLFormValues{
    id:number=0;
    codigo:number=0;   
    fechas:string="";

        constructor(CATEdicionesL?:CATEdicionesLFormValues){
            if(CATEdicionesL){
                this.id = CATEdicionesL.id;
                this.codigo = CATEdicionesL.codigo;
                this.fechas = CATEdicionesL.fechas;
            }
        }
    }

    export interface getEdiciones {
        id: number;
        codigo: string;
        fechas: number;
    }
    
    export class getEdiciones implements getEdiciones {
        [x: string]: any;
       
        constructor(init?: getEdicionesFormValues) {
            Object.assign(this, init);
        }
    }
    
    export class getEdicionesFormValues {
        id: number = 0
        codigo: string = "";
        fechas: number = 0; 
       
        constructor(getEdiciones?: getEdicionesFormValues) {
            if (getEdiciones) {
                this.id = getEdiciones.id;
                this.codigo = getEdiciones.codigo;
                this.fechas = getEdiciones.fechas;
            }
        }
    }

    export interface CATEdiciones2 {
        numeroEdicion:number;
        id:number;
        codigoCuenta:string;
        fechaDeInicioInscripcion: any
        fechaDeFinalizacionInscripcion: any
        fechaDeInicioDuracion: any
        fechaDeFinalizacionDuracion: any
        limiteCupo: number
        cupoActual: number
        edicionEspecial: string
        preInscripcion: string
        aprobadoPor: string
        catCursosId: string
        year: any
        fechaInicioEntrevista: any
        fechaFinalEntrevista: any
        fechaInicioPropedeutico: any
        fechaFinalPropedeutico: any
        catedratico: string
        nivel: string
        certificacion: string
    }